window.MAPY_CZ_API_KEY = 'PHm-W-JyBnKI48x4O2_EvMd_FBoLXVxj8mn1DSjB96s';

window.isMobileOrTablet = window.matchMedia(
  "only screen and (max-width: 992px)"
).matches;

window.isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

lightbox.option({
  albumLabel: `${I18n.t("js.attractions.photo")} %1 ${I18n.t(
    "js.attractions.of"
  )} %2`,
  wrapAround: true,
  fadeDuration: 200,
  imageFadeDuration: 200,
  resizeDuration: 300,
  alwaysShowNavOnTouchDevices: true,
  positionFromTop: 150,
});


document.addEventListener("DOMContentLoaded", function () {
  //turbolinks:load
  fontAwesomeDom.watch();

  FAVOURITES.updateSummary(); //renders heart with stored favourites

  // smooth scroll to local links
  // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //   anchor.addEventListener("click", function(e) {
  //     e.preventDefault();
  //
  //     document.querySelector(this.getAttribute("href")).scrollIntoView({
  //       behavior: "smooth"
  //     });
  //   });
  // });
});

//function which attrach backToTop button (arrow up) button a chosen page
window.setupBackToTopButton = (opts = {}) => {
  opts.offset = opts.offset || "1rem";

  const backTop = document.createElement("a");
  backTop.setAttribute("data-turbolinks", false);
  backTop.id = "back-top-button";
  backTop.innerHTML =
    opts.innerHTML ||
    '<i id="back-top-icon" class="fas fa-chevron-circle-up"></i>';

  backTop.style.position = "fixed";
  backTop.style.right = opts.offset;
  backTop.style.bottom = "-100px";
  backTop.style["transition-property"] = "bottom";
  if (!opts.transition) opts.transition = {};
  backTop.style["transition-duration"] = `${opts.transition.duration || 800}ms`;
  backTop.style["transition-timing-function"] =
    opts.transition.timingFunction || "linear";

  window.addEventListener("scroll", () => {
    if (window.pageYOffset < 1500) {
      $("#back-top-button").css("bottom", "-100px");
    } else $("#back-top-button").css("bottom", opts.offset);
  });

  //our local #links are handled smootly by a function in application.js
  backTop.addEventListener("click", (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // Remove hash from URL:
    // history.pushState(
    //   "",
    //   document.title,
    //   window.location.pathname + window.location.search
    // );
    e.preventDefault();
  });

  document.body.appendChild(backTop);
};

//this function solves background scrolling when iziModal is opened on Ios
window.fixBackgroundScroll = () => {
  if (!isMobileOrTablet) {
    return;
  }

  $("body").css("overflow", "hidden");
  $("body").css("position", "fixed");
  $("body").css("overscroll-behavior", "none");
};

window.unFixBackgroundScroll = () => {
  if (!isMobileOrTablet) {
    return;
  }

  $("body").css("overflow", "auto");
  $("body").css("position", "static");
  $("body").css("overscroll-behavior", "auto");
  $("html").removeClass("iziModal-isOverflow iziModal-isAttached");
};